import React, { useState } from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import TableSection from "./TableSection";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import { useQuery } from "@tanstack/react-query";
import { listarTodos, QUERY_LISTAR_TODOS_AGENDAMIENTOS_SPA } from "../../../services/agendamientosSpaServicios";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/reservas",
    label: "Reservas por Tipo",
  },
  {
    path: "/reservas/spa",
    label: "Reserva Spa",
  },
  {
    path: "/reservas/spa/listar",
    label: "Listar",
    isActive: true,
  }
];

function ListaAgendamientosSpa() {
  // Filtros de query, Eg: ?nombreMascota=Draco&nombrePropietario=Pedro
  const [queryParams, setQueryParams] = useState("");

  const {
    data: paginaAgendamientos,
    isLoading,
    isError,
  } = useQuery({
      queryKey: [
        QUERY_LISTAR_TODOS_AGENDAMIENTOS_SPA, 
        queryParams
      ],
      queryFn: async () => await listarTodos(queryParams),
    });

  const actualizarFiltroQuery = (filtrosQuery: string) => {
    setQueryParams(filtrosQuery);
  }

  return (
    <>
      <Page
        description="Visualiza y cancela agendamientos de Spa"
        title="Agendamientos de Spa"
        breadCrumbs={breadCrumbs}
      >
        <TableSection
          actualizarFiltroQuery={actualizarFiltroQuery}
          isLoading={isLoading} 
          paginaAgendamientos={paginaAgendamientos} />
      </Page>
      {isError && <ServerErrorModal />}
    </>
  );
}

export default ListaAgendamientosSpa;
